import * as types from "./mutation-types";

export const positionStream = ({ commit }, payload) => {
  commit(types.SET_STREAM_POSITION, payload);
};

export const orderStream = ({ commit }, payload) => {
  commit(types.SET_STREAM_ORDER, payload);
};

export const deletePositionStream = ({ commit }, payload) => {
  commit(types.SET_STREAM_POSITION, payload);
};

export const deleteOrderStream = ({ commit }, payload) => {
  commit(types.SET_STREAM_ORDER, payload);
};

export const qtdPositionStream = ({ commit, state }, payload) => {
  let qtd;
  if (payload == 0) {
    qtd = 0;
  } else if (payload == "remover") {
    qtd = state.qtd_position - 1;
  } else {
    qtd = state.qtd_position + 1;
  }

  commit(types.SET_STREAM_QTD, qtd);
};
